import Page from "webPage/Page";

Page.register('category', () => {
    $("body").on("click", ".js-open-filters", function () {
        $("body").addClass("show-filters");
        return false;
    }).on("click", ".js-close-filters", function () {
        $("body").removeClass("show-filters");
    })
});
